var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.article)?_c('div',{staticClass:"small-12 articleFeatureImage flex"},[_c('picture',{staticClass:"small-12 large-9 float-left"},[_c('img',{attrs:{"src":_vm.article.links.feature_image,"alt":"Feature Image"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }